import { render, staticRenderFns } from "./DentalForm.vue?vue&type=template&id=7694c650&scoped=true&"
import script from "./DentalForm.vue?vue&type=script&lang=js&"
export * from "./DentalForm.vue?vue&type=script&lang=js&"
import style0 from "./DentalForm.vue?vue&type=style&index=0&id=7694c650&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7694c650",
  null
  
)

export default component.exports